/**
 * @generated SignedSource<<da7edbef4ffc88f52e9add543a764781>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductRegistrationAvailability = "hidden" | "private" | "public" | "%future added value";
export type ProductSelect_SelectedProductQuery$variables = {
  hideNonEventAppProducts: boolean;
  id: string;
};
export type ProductSelect_SelectedProductQuery$data = {
  readonly product: {
    readonly badge?: {
      readonly " $fragmentSpreads": FragmentRefs<"BadgeFragment">;
    } | null;
    readonly hasEventsApp?: boolean;
    readonly id?: string;
    readonly isAutoJoined?: boolean;
    readonly name?: string;
    readonly registrationAvailability?: ProductRegistrationAvailability;
    readonly slug?: string;
    readonly viewerPermissions?: ReadonlyArray<string>;
    readonly " $fragmentSpreads": FragmentRefs<"ProductDropdownItemFragment">;
  } | null;
};
export type ProductSelect_SelectedProductQuery = {
  response: ProductSelect_SelectedProductQuery$data;
  variables: ProductSelect_SelectedProductQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hideNonEventAppProducts"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAutoJoined",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "registrationAvailability",
  "storageKey": null
},
v9 = {
  "condition": "hideNonEventAppProducts",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "hasEventsApp",
      "args": [
        {
          "kind": "Literal",
          "name": "kind",
          "value": "events"
        }
      ],
      "kind": "ScalarField",
      "name": "hasProductApp",
      "storageKey": "hasProductApp(kind:\"events\")"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductSelect_SelectedProductQuery",
    "selections": [
      {
        "alias": "product",
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Badge",
                "kind": "LinkedField",
                "name": "badge",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BadgeFragment"
                  }
                ],
                "storageKey": null
              },
              (v9/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProductDropdownItemFragment"
              }
            ],
            "type": "Product",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProductSelect_SelectedProductQuery",
    "selections": [
      {
        "alias": "product",
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Badge",
                "kind": "LinkedField",
                "name": "badge",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "kind",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "icon",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emoji",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mediaUrl",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startsAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endsAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "type": "Product",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7a11007534782efc83cee137bce2e7dc",
    "id": null,
    "metadata": {},
    "name": "ProductSelect_SelectedProductQuery",
    "operationKind": "query",
    "text": "query ProductSelect_SelectedProductQuery(\n  $id: ID!\n  $hideNonEventAppProducts: Boolean!\n) {\n  product: node(id: $id) {\n    __typename\n    ... on Product {\n      id\n      name\n      slug\n      isAutoJoined\n      viewerPermissions\n      registrationAvailability\n      badge {\n        ...BadgeFragment\n        id\n      }\n      hasEventsApp: hasProductApp(kind: events) @include(if: $hideNonEventAppProducts)\n      ...ProductDropdownItemFragment\n    }\n    id\n  }\n}\n\nfragment BadgeFragment on Badge {\n  kind\n  color\n  icon\n  emoji\n  mediaUrl\n}\n\nfragment ProductDropdownItemFragment on Product {\n  name\n  type\n  startsAt\n  endsAt\n  status\n  badge {\n    ...BadgeFragment\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7d7e0191900a1359bb1d153ade35c7f1";

export default node;
